
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/register",
      function () {
        return require("private-next-pages/auth/register/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/register"])
      });
    }
  